import { render, staticRenderFns } from "./UserPayinResponse.vue?vue&type=template&id=35cf6b94&"
import script from "./UserPayinResponse.vue?vue&type=script&lang=js&"
export * from "./UserPayinResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserPayinResponse.vue"
export default component.exports